enum PermissionsViewMode {
  VIEW = 'View',
  EDIT = 'Edit',
  ADD = 'Add',
}

export default PermissionsViewMode;
